import React, { useState, useEffect } from 'react';
import {
    Box,
    Tooltip,
    Chip,
    Grid,
    Stack,
    Select,
    Typography,
    TextField,
    IconButton,
    MenuItem,
    InputAdornment,
    FormControl,
    InputLabel,
    Button,
    Slider,

} from '@mui/material'
import { Add, Download, Delete, Replay, Search, FilterAlt, Info, Create, BurstMode } from '@mui/icons-material'
import Tables from '@components/table';
import apiService from '@services/common'
import { useGlobalContext } from '@providers/globalProvider';
import AddDrawer from './addDrawer';
import EditDrawer from './editDrawer';
import DetailDrawer from './detailDrawer';
import ImagesDrawer from './imagesDrawer'
import { saveAs } from 'file-saver';
import { dataToFormData } from '@utils/common'
import { useSelector, useDispatch } from 'react-redux'
import { updateBreadcrumb } from '@redux/commonReducer'
import { uploadUrl } from "@services/axios";

function valuetext(value) {
    if (!Array.isArray(value)) return '';
    const [min, max] = value.map(v => parseFloat(v) * 1000000);
    return `${min.toLocaleString('vi-VN')} đ - ${max.toLocaleString('vi-VN')} đ`;
}

const Product = () => {
    const [data, setData] = useState([])

    const [categories, setCategories] = useState([])

    const [categoryId, setCategoryId] = useState(0)
    const dispatch = useDispatch()


    const [keyword, setKeyword] = useState('')
    const [selectedRows, setSelectedRows] = useState([])
    const { showNotification, showLoading, hideLoading, openModal, closeModal, openDrawer, closeDrawer, showConfirm, closeConfirm } = useGlobalContext()

    const columns = [

        {
            field: 'updated_at',
            headerName: 'Chi tiết',
            width: 150,
            editable: false,
            renderCell: (params) => (
                <>
                    {/* <IconButton
                        onClick={() => handleShowDetail(params.row.all_attributes, params.row.attribute_fields, params.row.id)}
                        sx={{ border: 'none', alignItems: 'flex-start' }}
                    >
                        <Info />
                    </IconButton> */}
                    <IconButton
                        onClick={() => handleEdit(params.row)}
                        sx={{ border: 'none', alignItems: 'flex-start' }}
                    >
                        <Create />
                    </IconButton>
                    <IconButton
                        onClick={() => handleShowImages(params.row.image_list, params.row.id)}
                        sx={{ border: 'none', alignItems: 'flex-start' }}
                    >
                        <BurstMode />
                    </IconButton>
                </>
            )
        },
        {
            field: 'image',
            headerName: 'Ảnh đại diện',
            width: 150,
            editable: false,
            renderCell: (params) => (
                <img
                    src={params.value ? uploadUrl + params.value : '/noimg.jpeg'}
                    alt="Ảnh đại diện"
                    style={{ width: '60px', height: 'auto', padding: '5px' }}
                />
            )
        },

        {
            field: 'title',
            headerName: 'Tiêu đề',
            width: 300,
            editable: true,
        },
        {
            field: 'price',
            headerName: 'Giá',
            width: 300,
            editable: true,
            renderCell: (params) => {
                return params.value.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' });
            }
        },
        {
            field: 'category',
            headerName: 'Thuộc danh mục',
            width: 200,
            editable: false,
            renderCell: (params) => (
                <Chip label={params.row?.category?.title} color='info' />
            )
        },


        {
            field: 'slug',
            headerName: 'slug',
            width: 200,
            editable: true,
        },
        {
            field: 'is_public',
            headerName: 'Hiển thị',
            width: 200,
            editable: true,
            renderCell: (params) => params.value ? <Chip label="Hiển thị" color="primary" /> : <Chip label="Ẩn" color="error" />,
            renderEditCell: (params) => (
                <Select
                    value={params.value !== undefined ? String(params.value) : ""}
                    onChange={(event) => {
                        const newValue = event.target.value;

                        params.api.setEditCellValue({
                            id: params.id,
                            field: params.field,
                            value: newValue === "1"
                        });
                    }}
                    fullWidth
                >
                    <MenuItem key={1} value="1" selected={params.value === "1"}>
                        Hiển thị
                    </MenuItem>
                    <MenuItem key={0} value="0" selected={params.value === "0"}>
                        Ẩn
                    </MenuItem>
                </Select>
            )
        },
    ];

    const breadcrumb =
        [
            {
                name: 'Sản phẩm',
                url: 'product'
            }
        ]

    const styleButton = {
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
        border: 'none'
    }

    const handleEdit = (data) => {
        openDrawer({
            content: <EditDrawer submitFunction={doUpdate} data={data} />,
            onCloseCallback: () => { }
        })
    }

    const handleShowImages = (data, id) => {
        openDrawer({
            content: <ImagesDrawer productId={id} images={data} />,
            onCloseCallback: () => { }
        })
    }

    const doUpdate = (data) => {
        debugger
        delete data.category
        showLoading()
        const formData = dataToFormData(data)
        formData.append('_method', 'PUT');

        apiService.postWithMedia(`product/${data.id}`, formData)
            .then(res => {
                loadData()
                hideLoading()
                showNotification(
                    'Gửi đi thành công',
                    'success'
                );
            })
            .catch(err => {
                hideLoading()
                showNotification(err.message, 'error')
            })
    }

    const processRowUpdate = (newRow, oldRow) => {
        showLoading()
        setData((prevRows) =>
            prevRows.map((row) => (row.id === oldRow.id ? { ...newRow } : row))
        )
        apiService.put(`product/${newRow.id}`, newRow)
            .then(res => {
                showNotification("Update thành công", 'success');
                hideLoading()
            })
            .catch(err => {
                showNotification("Đã có lỗi xảy ra, liên hệ quản trị viên để được hỗ trợ", 'error');
                hideLoading()
            })
        return newRow
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            apiService.get(`product?keyword=${keyword}`)
                .then(res => {
                    setData(res.data.data)
                })
                .catch(err => {
                    showNotification("Đã có lỗi xảy ra, liên hệ quản trị viên để được hỗ trợ", 'error');
                })
        }
    }

    const handleAddNew = () => {
        openDrawer({
            content: <AddDrawer submitFunction={doAddNew} />,
            onCloseCallback: () => { }
        })
    }

    const doAddNew = (data) => {
        showLoading()
        const formData = dataToFormData(data)
        apiService.postWithMedia(`product`, formData)
            .then(res => {
                loadData()
                hideLoading()
                showNotification(
                    'Gửi đi thành công',
                    'success'
                );
            })
            .catch(err => {
                hideLoading()
                showNotification(err.message, 'error')
            })
    }

    const doDelete = () => {
        showLoading()
        apiService.delete(`product/${selectedRows}`)
            .then(res => {
                loadData()
                setSelectedRows([])
                closeConfirm()
                showNotification('Xoá thành công', 'success')
            })
            .catch(err => {
                showNotification(err.message, 'error')
            })
    }

    const handleDelete = () => {
        showConfirm({
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc muốn xoá bản ghi này? Sau khi xoá, dữ liệu có thể không khôi phục lại được',
            onConfirm: () => doDelete(),
            oncancel: () => closeConfirm()
        })
    }

    const loadData = () => {
        showLoading()
        apiService.get('product')
            .then(res => {
                setData(res.data.data)
                hideLoading()
            })
            .catch(err => {
                console.log(err)
                showNotification('Đã có lỗi -  vui lòng liên hệ với quản trị viên', 'error')
                hideLoading()
            })
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value)
    }

    useEffect(() => {
        loadData()
        dispatch(updateBreadcrumb(breadcrumb))
    }, [])

    useEffect(() => {
        showLoading()
        apiService.get('product-category')
            .then(res => {
                setCategories(res.data.data)
                hideLoading()
            })
            .catch(err => {
                console.error(err)
                hideLoading()
            })
    }, [])

    const handleFilter = () => {
        showLoading()
        apiService.get(`product?&product_category_id=${categoryId}`)
            .then(res => {
                setData(res.data.data)
                hideLoading()
            })
            .catch(err => {
                console.error(err)
                showNotification('Đã có lỗi xảy ra, liên hệ quản trị viên', 'error')
            })
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box>
                <Typography variant='h5' sx={{ mb: 2 }}>Quản lý sản phẩm</Typography>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 2 }}>

                        <TextField
                            sx={{ minWidth: 250, mr: 2 }}
                            hiddenLabel
                            defaultValue={keyword}
                            onChange={handleChangeKeyword}
                            onKeyDown={handleKeyDown}
                            placeholder="Nhập từ khóa tìm kiếm..."
                            variant="outlined"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <FormControl sx={{ minWidth: 150, mr: 2 }} size="small">
                            <InputLabel id="demo-simple-select-label">Chọn danh mục</InputLabel>
                            <Select
                                size='small'
                                labelId="demo-simple-select-label"
                                value={categoryId}
                                label="Chọn danh mục"
                                onChange={(e) => setCategoryId(e.target.value)}
                            >
                                <MenuItem value={0}>Không lọc</MenuItem>
                                {categories.map(item => <MenuItem value={item.id}>{item.title}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <Button
                            onClick={() => handleFilter()}
                            variant='outlined'
                            color='secondary'
                            size='small'
                            startIcon={<FilterAlt />}
                        >
                            Lọc
                        </Button>
                    </Grid>

                    <Grid
                        size={{ xs: 12, md: 6 }}
                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%', overflow: 'auto' }}
                    >
                        <Stack direction={'row'} spacing={0}>
                            <Tooltip placement="bottom" content="Thêm mới">
                                <IconButton
                                    sx={styleButton}
                                    onClick={() => handleAddNew()}
                                >
                                    <Add />
                                </IconButton>
                            </Tooltip>
                            <Tooltip placement="bottom" content="Xoá">
                                <IconButton
                                    sx={styleButton}
                                    color="error"
                                    disabled={!(selectedRows.length > 0)}
                                    onClick={() => handleDelete()}
                                >
                                    <Delete />
                                </IconButton>
                            </Tooltip>

                        </Stack>
                    </Grid>

                </Grid>
            </Box>
            <Box>
                {data &&
                    data.length > 0 &&
                    <Tables
                        rows={data}
                        columns={columns}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        processRowUpdate={processRowUpdate} />
                }
            </Box>
        </Box>
    );
}

export default Product;